export const getLongDayName = (dayOfWeek: number, language: string) => {
    return new Date(1970, 1 - 1, dayOfWeek - 3).toLocaleString(language, { weekday: 'long' /* or 'long' */ })
}

export const getShortDayName = (dayOfWeek: number, language: string) => {
    return new Date(1970, 1 - 1, dayOfWeek - 3).toLocaleString(language, { weekday: 'short' /* or 'long' */ })
}

export const isActive = (dayOfWeek: number, start: Date, end: Date, now: Date) => {
    if (!isToday(dayOfWeek, now))
        return false;
    const nowTime = now.getTime();
    return nowTime >= start.getTime() && nowTime <= end.getTime();
}

export const isToday = (dayOfWeek: number, now: Date) => {
    return now.getDay() === dayOfWeek;
}

export const getWeekDays = (): number[] => {
    return [1, 2, 3, 4, 5, 6, 0]
}
